import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import SiteLayout from "@/components/SiteLayout";
import DonatePinGate from "@/components/DonatePinGate";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Programs from "@/pages/Programs";
import Events from "@/pages/Events";
import Resources from "@/pages/Resources";
import Donate from "@/pages/Donate";
import Contact from "@/pages/Contact";
import Community from "@/pages/Community";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <DonatePinGate>
        <BrowserRouter>
          <Routes>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/programs" element={<Programs />} />
              <Route path="/events" element={<Events />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/community" element={<Community />} />
              <Route path="/donate" element={<Donate />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin" element={<Admin />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </DonatePinGate>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
